import { styled } from 'styled-components'

export const PricePlanMobileSwitcherUi = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 801px) {
    display: none;
  }
`

export const PricePlanMobileSwitcherToggleUi = styled.div`
  position: relative;
  display: flex;
  background-color: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 2rem;
  padding: 4px;
  gap: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`

export const PricePlanMobileSwitcherToggleButtonUi = styled.button<{
  isSelected: boolean
}>`
    z-index: 1;
    border: none;
    background: transparent;
    padding: 10px 24px;
    border-radius: 2rem;
    color: #181c39;
    cursor: pointer;
    transition: color 0.3s ease;
    font-size: 1rem;

    ${p => p.isSelected && 'color: #fff;'}
`

export const PricePlanMobileSwitcherSliderUi = styled.div<{
  isActive: boolean
}>`
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 8px);
  background: #00a0ff;
  border-radius: 2rem;
  transition: left 0.3s ease;

  ${p => p.isActive && 'left: 50%;'}
`

export const PriceElementPeriodSavingMobileUi = styled.div<{
  isVisible: boolean
}>`
  text-transform: uppercase;
  position: absolute;
  top: -15px;
  right: -5px;
  background-color: #b3fc69;
  color: #181c39;
  font-size: 0.7rem;
  padding: 4px 8px;
  border-radius: 999px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 0.3s ease, transform 0.3s ease;

  ${p =>
    p.isVisible &&
    `
      opacity: 1;
      transform: scale(1);
    `}
`
